import anime from 'animejs';

export default {
    sync: false,
    leave: ({ current }) => anime({
        targets: current.container,
        duration: 400,
        easing: 'easeInOutQuad',
        opacity: [1, 0],
    }).finished,
    enter: ({ next }) => anime({
        targets: next.container,
        duration: 400,
        easing: 'easeInOutQuad',
        opacity: [0, 1],
    }).finished,
};
